import React from 'react';
import LincolnMKTCard from '../components/LincolnMKTCard';
import CadillacEscaladeCard from '../components/CadillacEscaladeCard';
import MercedesSprinterCard from '../components/MercedesSprinterCard';
import InteractiveCard from '../components/InteractiveCard';
import jetBlackBg from '../assets/images/jetblack-bg.png';

const MobileExclusiveFleet = () => {
  return (
    <div style={styles.container}>
      <img
        src={jetBlackBg}
        alt="Luxury Fleet Background"
        style={styles.backgroundImage}
      />
      <h1 style={styles.title}>Explore Our Luxury Fleet</h1>
      
      <div style={styles.cardContainer}>
        <div style={styles.card}>
          <LincolnMKTCard />
        </div>
        <div style={styles.card}>
          <CadillacEscaladeCard />
        </div>
        <div style={styles.card}>
          <MercedesSprinterCard />
        </div>
        <div style={styles.card}>
          <InteractiveCard />
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: '0',
    backgroundColor: '#ffffff',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  // La imagen se extiende de lado a lado de la pantalla
  backgroundImage: {
    width: '100vw',
    marginLeft: 'calc(-50vw + 50%)',
    height: 'auto',
    objectFit: 'cover',
    marginBottom: '20px',
  },
  title: {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    color: '#0d2b3e',
    textAlign: 'center',
    marginBottom: '20px',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    textShadow: '1px 1px 4px rgba(0, 0, 0, 0.3)',
  },
  cardContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '30px', // Mayor espacio entre tarjetas
    width: '100%',
    maxWidth: '1000px',
    padding: '0 20px', // Espaciado horizontal
  },
  card: {
    padding: '20px', // Mayor padding para un look más elegante
    borderRadius: '15px', // Bordes más redondeados
    backgroundColor: '#fff',
    boxShadow: '0 6px 20px rgba(0, 0, 0, 0.1)', // Sombra más profunda y elegante
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    border: 'none',
  },
};

export default MobileExclusiveFleet;
